import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { removeAccessToken } from "../../Util/authHeader";
import { useDispatch, useSelector } from "react-redux";
import { setUserDetails } from "../../Store/Slices/UserSlice";
import { useTranslation } from "react-i18next";

import { Dropdown, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";

import { avatar, logo } from "../../Assets/images";

import CustomSearchBar from "../../Components/CustomSearchBar";
import BASEURL from "../../Config/global";
import { appDownload, Cog, MyMixes, RefreshIcon, crossIcon, hamburgerMenu, PlaylistIcon } from "../../Assets/svg";
import { userLogout } from "../../Store/Slices/APIs";
import AppDownloadTray from "../../Components/AppDownloadTray";
import { hideUrlForAge, hideUrlForCountry } from "../../Util/global_functions";
import { setLanguage } from "../../Store/Slices/LanguageSlice";
import { supportedLanguages } from "../../i18n";
import axios from "axios";

// import { currentUser } from "../../Config/data";

export const Header = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [logoutModal, setLogoutModal] = useState(false);
  const [succesModal, setSuccesModal] = useState(false);
  const [showAppDownloadTray, setShowAppDownloadTray] = useState(false);
  const [browserLanguage, setBrowserLanguage] = useState(() => {
    return navigator.language || navigator.userLanguage || "en";
  });
  const user = JSON.parse(localStorage.getItem("user"));
  const userCountry = JSON.parse(localStorage.getItem("user_country"));
  const userPrompts = useSelector((state) => state.user.userPrompts);
  const currentLanguage = useSelector((state) => state.language.current);
  const { t, i18n } = useTranslation();
  const languageName = useMemo(() => {
    if (currentLanguage === "es") {
      return t("language.spanish");
    }
    return t("language.english");
  }, [currentLanguage, t]);

  useEffect(() => {
    // console.clear();
  }, []);

  // Helper function to normalize language code
  const normalizeLanguage = (lang) => {
    if (!lang) return null;
    const normalized = lang.toLowerCase();
    if (normalized === "spanish" || normalized === "es" || normalized.startsWith("es-")) {
      return "es";
    }
    if (normalized === "english" || normalized === "en" || normalized.startsWith("en-")) {
      return "en";
    }
    return null;
  };

  useEffect(() => {
    console.log("🎯 Header: Language Sync Check:", {
      "user?.preferred_language": user?.preferred_language,
      "currentLanguage (Redux)": currentLanguage,
      "i18n.language": i18n.language,
      "localStorage": localStorage.getItem("preferred_language")
    });

    // Priority: 1. User's preferred_language from backend, 2. localStorage, 3. Browser language
    if (user?.preferred_language) {
      const normalizedUserLang = normalizeLanguage(user.preferred_language);
      console.log("👤 User language from backend:", {
        "raw": user.preferred_language,
        "normalized": normalizedUserLang,
        "current": currentLanguage
      });
      if (normalizedUserLang && normalizedUserLang !== currentLanguage) {
        console.log("🔄 Syncing user language to Redux and i18n");
        dispatch(setLanguage(normalizedUserLang));
        i18n.changeLanguage(normalizedUserLang);
      }
    } else {
      // Check if browser language is Spanish and localStorage has "en" or is empty
      const storedLang = localStorage.getItem("preferred_language");
      const browserLang = navigator.language || navigator.userLanguage;
      const isBrowserSpanish = browserLang && browserLang.toLowerCase().startsWith("es");

      if (isBrowserSpanish && (!storedLang || storedLang === "en")) {
        console.log("🌐 Browser language is Spanish, updating localStorage and Redux:", {
          "browserLang": browserLang,
          "storedLang": storedLang,
          "currentLanguage": currentLanguage
        });
        dispatch(setLanguage("es"));
        i18n.changeLanguage("es");
      } else if (!storedLang && i18n.language) {
        // If no stored preference, sync with i18n detected language (from browser)
        const detectedLang = i18n.language === "es" ? "es" : "en";
        console.log("🌐 No stored language, using browser detected:", {
          "i18n.language": i18n.language,
          "detectedLang": detectedLang,
          "currentLanguage": currentLanguage
        });
        if (detectedLang !== currentLanguage) {
          console.log("🔄 Syncing browser language to Redux");
          dispatch(setLanguage(detectedLang));
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (currentLanguage && i18n.language !== currentLanguage) {
      console.log("🔄 Syncing Redux language to i18n:", {
        "Redux": currentLanguage,
        "i18n": i18n.language
      });
      i18n.changeLanguage(currentLanguage);
    }
  }, [currentLanguage, i18n]);

  useEffect(() => {
    if (user && currentLanguage && user.preferred_language !== currentLanguage) {
      const updatedUser = { ...user, preferred_language: currentLanguage };
      localStorage.setItem("user", JSON.stringify(updatedUser));
    }
  }, [currentLanguage]);

  // Monitor browser language changes (for DevTools testing)
  useEffect(() => {
    const checkBrowserLanguage = () => {
      const currentBrowserLang = navigator.language || navigator.userLanguage || "en";
      const isBrowserSpanish = currentBrowserLang.toLowerCase().startsWith("es");
      const isBrowserEnglish = currentBrowserLang.toLowerCase().startsWith("en");

      // Detect if browser language changed
      if (currentBrowserLang !== browserLanguage) {
        console.log("🌐 Browser Language Changed Detected:", {
          "previous": browserLanguage,
          "new": currentBrowserLang,
          "isSpanish": isBrowserSpanish,
          "isEnglish": isBrowserEnglish
        });

        setBrowserLanguage(currentBrowserLang);

        // If browser language is Spanish and localStorage has "en" or is empty, update it
        if (isBrowserSpanish) {
          const storedLang = localStorage.getItem("preferred_language");
          if (!storedLang || storedLang === "en") {
            console.log("💾 Auto-updating localStorage to 'es' based on browser language change");
            dispatch(setLanguage("es"));
            i18n.changeLanguage("es");
          }
        } else if (isBrowserEnglish) {
          // If browser language is English and localStorage has "es", update it
          const storedLang = localStorage.getItem("preferred_language");
          if (storedLang === "es") {
            console.log("💾 Auto-updating localStorage to 'en' based on browser language change");
            dispatch(setLanguage("en"));
            i18n.changeLanguage("en");
          }
        }
      }
    };

    // Check immediately
    // checkBrowserLanguage();

    // Listen for languagechange event (if supported)
    // if (window.addEventListener) {
    //   window.addEventListener("languagechange", checkBrowserLanguage);
    // }

    // Also check periodically (every 2 seconds) for DevTools changes
    const intervalId = setInterval(checkBrowserLanguage, 2000);

    return () => {
      if (window.removeEventListener) {
        window.removeEventListener("languagechange", checkBrowserLanguage);
      }
      clearInterval(intervalId);
    };
  }, [browserLanguage, dispatch, i18n]);

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleLogout = () => {
    setLogoutModal(false);
    setSuccesModal(true);
    removeAccessToken();
    localStorage.removeItem("user");
    localStorage.removeItem("is_primary");
    localStorage.removeItem("user_email");
    localStorage.removeItem("ip");
    localStorage.removeItem("userId");
    dispatch(setUserDetails(null));
    setTimeout(() => {
      setSuccesModal(false)
      navigate("/login");
      window.location.reload(false)
    }, 500);
  };

  const hideAppDownloadTray = () => {
    setShowAppDownloadTray(false);
  }

  const updatePreferredLanguage = async (languageCode) => {
    try {
      const currentUser = JSON.parse(localStorage.getItem("user"));

      // Only update backend if user is logged in
      if (!currentUser || !currentUser.id) {
        return;
      }

      // Map language code to backend format
      const languageMap = {
        "en": "english",
        "es": "spanish"
      };

      const backendLanguage = languageMap[languageCode] || "english";

      const formData = new FormData();
      formData.append("preferred_language", backendLanguage);

      const response = await axios.post(
        `${BASEURL}/api/user/update-preferred-language/`,
        formData
      );

      if (!response.data.error) {
        // Update user object in localStorage with new preferred language
        const updatedUser = { ...currentUser, preferred_language: languageCode };
        localStorage.setItem("user", JSON.stringify(updatedUser));
        dispatch(setUserDetails(updatedUser));
        window.location.reload(false);
      }
    } catch (error) {
      console.error("Error updating preferred language:", error);
      // Continue with local update even if API call fails
    }
  };

  const handleLanguageSelect = async (code) => {
    if (code && code !== currentLanguage) {
      // Update local state first for immediate UI update
      dispatch(setLanguage(code));
      i18n.changeLanguage(code);
      localStorage.setItem("preferred_language", code);


      // Update backend (function will check if user is logged in)
      await updatePreferredLanguage(code);
    }
  };

  return (
    <>
      <div className="headerWrapper">
        <div className="row">
          <div className="col-12 text-end">
            <div className="d-flex align-items-center justify-content-lg-end justify-content-between">
              {/* <div className="headerSearchWrapper">
              <p className="smallText d-none d-md-block mb-0 me-2">Search</p>
              <CustomSearchBar
                placeholder="What do you want to listen to?"
                onChange={(event) => {
                  handleSearch(event);
                }}
              />
            </div> */}
              <Link className="logo d-block d-lg-none" to="/home">
                <img src={logo} alt="Logo" />
              </Link>
              <div className="d-flex align-items-center gap-0 gap-lg-1">

                <button
                  onClick={() => { setShowAppDownloadTray(true); }}
                  className="notButton d-flex d-lg-none align-items-center p-2">
                  <img
                    src={appDownload}
                    style={{ filter: 'unset', width: '23px', height: '23px' }}
                    alt="saved mix"
                    className="playerActionIcon"
                  />
                </button>

                <button className="notButton d-flex align-items-center p-2" onClick={() => { navigate("/playlists"); }}>
                  {/* <img
                    src={PlaylistIcon}
                    style={{ filter: 'unset', width: '23px', height: '23px' }}
                    alt="saved mix"
                    className="playerActionIcon"
                    onClick={() => { navigate("/playlists"); }}
                  /> */}
                  <svg width="27"  id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88.2 68.93">
                    <defs>
                      <style>{`
                        .playlist-cls-3 {
                          fill: #fff;
                        }`}
                      </style>
                    </defs>
                    <g id="Layer_1-2" data-name="Layer 1">
                      <g>
                        <path class="playlist-cls-3" d="M49.07,35.5c0-1.15-.94-2.09-2.09-2.09H2.09c-1.15,0-2.09.94-2.09,2.09s.94,2.09,2.09,2.09h44.9c1.15,0,2.09-.93,2.09-2.09Z" />
                        <path class="playlist-cls-3" d="M2.09,20.88h51.16c1.15,0,2.09-.93,2.09-2.09s-.94-2.09-2.09-2.09H2.09c-1.15,0-2.09.94-2.09,2.09s.94,2.09,2.09,2.09Z" />
                        <path class="playlist-cls-3" d="M2.09,4.18h55.34c1.15,0,2.09-.94,2.09-2.09s-.94-2.09-2.09-2.09H2.09C.94,0,0,.94,0,2.09s.94,2.09,2.09,2.09Z" />
                        <path class="playlist-cls-3" d="M87.13,15.29l-15.82-14.15c-.97-.93-2.6-1.19-3.83-.66-1.23.53-2.24,1.73-2.24,3.07v46.77c-2.49-2.9-8.08-4.77-13.98-4.77-9.83,0-17.43,5.13-17.43,11.69s7.75,11.69,17.59,11.69,17.56-5.13,17.56-11.69l.04-33.64,16.39-2.57c1.25-.21,2.27-1.09,2.65-2.31.38-1.21.04-2.52-.92-3.44ZM51.01,65.13c-6.83,0-12.36-3.56-12.36-7.95s5.53-7.95,12.36-7.95,12.36,3.56,12.36,7.95-5.53,7.95-12.36,7.95ZM83.36,18.54l-12.28,1.9c-1.51.23-2.88-.94-2.88-2.46V4.92c0-.96,1.13-1.47,1.85-.85l13.98,12.13c.86.74.45,2.15-.67,2.33Z" />
                      </g>
                    </g>
                  </svg>
                </button>

                <button className="notButton d-flex align-items-center p-2" onClick={() => { navigate("/my-mixes"); }}>
                  {/* <img
                    src={MyMixes}
                    style={{ filter: 'unset', width: '23px', height: '23px' }}
                    alt="saved mix"
                    className="playerActionIcon"
                    onClick={() => { navigate("/my-mixes"); }}
                  /> */}
                  <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" width="25" height="52.89" viewBox="0 0 61.2 52.89">
                    <defs>
                      <style>
                        {`
                        .my-mix-cls-1 {
                          stroke - linecap: round;
                        }
                        .my-mix-cls-1, .my-mix-cls-2 {
                          fill: none;
                          stroke: #fff;
                          stroke-linejoin: round;
                          stroke-width: 2.09px;
                        }
                       `}
                      </style>
                    </defs>
                    <g id="Layer_19" data-name="Layer 19">
                      <g>
                        <rect class="my-mix-cls-2" x="15.94" y="18.04" width="44.22" height="33.8" />
                        <path class="my-mix-cls-1" d="M38.05,28.84c.16-.21,2.43-2.99,5.37-2.49,2.27.38,3.61,2.5,4.05,3.57,1.44,3.5-1.38,7.87-6.94,12.78-1.42,1.26-3.63,1.26-5.05,0-5.54-4.89-8.28-9.2-6.85-12.7.44-1.08,1.78-3.32,4.05-3.71,2.94-.5,5.21,2.34,5.37,2.55Z" />
                        <polyline class="my-mix-cls-1" points="8.48 43.21 8.48 9.32 48.37 9.32" />
                        <polyline class="my-mix-cls-1" points="1.04 34.94 1.04 1.04 40.93 1.04" />
                      </g>
                    </g>
                  </svg>
                </button>

                <Dropdown className="headerDropdown toggleHead">
                  <Dropdown.Toggle
                    variant="success"
                    id="dropdown-basic"
                    className="headerDropdownButton p-2"
                  >
                    <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" width="25" height="40.85" viewBox="0 0 50.81 40.85">
                      <defs>
                        <style>
                          {`.hamburger-cls-1 {
                            fill: none;
                          stroke: #fff;
                          stroke-linecap: round;
                          stroke-miterlimit: 10;
                          stroke-width: 3.26px;
                          }`}
                        </style>
                      </defs>
                      <g id="Layer_19" data-name="Layer 19">
                        <g id="Layer_2-2" data-name="Layer 2">
                          <g id="Layer_27" data-name="Layer 27">
                            <line class="hamburger-cls-1" x1="1.63" y1="1.63" x2="49.18" y2="1.63" />
                            <line class="hamburger-cls-1" x1="1.63" y1="20.43" x2="49.18" y2="20.43" />
                            <line class="hamburger-cls-1" x1="1.63" y1="39.22" x2="49.18" y2="39.22" />
                          </g>
                        </g>
                      </g>
                    </svg>
                    {/* <img src={hamburgerMenu} alt="Menu" style={{ filter: 'unset', width: '23px', height: '23px' }} /> */}
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="headerDropdownMenu">
                    <Link to={"/playlists"} className="headerDropdownAction">
                      {t("header.playlists")}
                    </Link>
                    <Link to={"/my-mixes"} className="headerDropdownAction">
                      {t("header.mixes")}
                    </Link>

                    {
                      hideUrlForAge() && hideUrlForCountry(userCountry) && (
                        <>
                          <Link
                            to={"https://store.scofa.com/"}
                            target="_blank"
                            className="headerDropdownAction"
                          >
                            {t("nav.sleepStore")}
                          </Link>
                          <Link
                            to={"https://scofa.com/search-for-sleep-provider/"}
                            target="_blank"
                            className="headerDropdownAction"
                          >
                            {t("nav.sleepDoctors")}
                          </Link>
                          <Link
                            to={"https://scofa.com/check-sleep-disorder-symptoms/"}
                            target="_blank"
                            className="headerDropdownAction"
                          >
                            {t("nav.checkSymptoms")}
                          </Link>
                        </>
                      )
                    }

                  </Dropdown.Menu>
                </Dropdown>


                <Dropdown className="headerDropdown toggleHead">
                  <Dropdown.Toggle
                    variant="success"
                    id="dropdown-basic"
                    className="headerDropdownButton"
                  >
                    <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" width="25" height="53.99" viewBox="0 0 53.99 53.99">
                      <defs>
                        <style>
                          {`.setting-cls-1 {
                            fill: none;
                            stroke: #fff;
                            stroke-linecap: round;
                            stroke-linejoin: round;
                            stroke-width: 2px;
                          }`}
                        </style>
                      </defs>
                      <g id="Layer_19" data-name="Layer 19">
                        <path class="setting-cls-1" d="M35.66,27c0,4.79-3.88,8.67-8.67,8.67s-8.67-3.88-8.67-8.67,3.88-8.67,8.67-8.67,8.67,3.88,8.67,8.67ZM44.79,36.62v.03l.57.57c2.27,2.25,2.27,5.92.01,8.17-2.25,2.25-5.91,2.25-8.16,0l-.6-.6c-1.21.66-2.51,1.18-3.84,1.59v.84c0,3.19-2.58,5.77-5.77,5.77h-.01c-3.19,0-5.77-2.58-5.77-5.77v-.84c-1.33-.4-2.63-.92-3.84-1.59l-.6.6c-2.25,2.25-5.91,2.25-8.16,0-2.26-2.26-2.25-5.92.01-8.17l.57-.57v-.03.03-.03c-.66-1.21-1.18-2.51-1.59-3.84h-.84c-3.19,0-5.77-2.58-5.77-5.77h0c0-3.2,2.58-5.78,5.77-5.78h.84c.4-1.33.92-2.63,1.59-3.84l-.6-.6c-2.25-2.25-2.25-5.91,0-8.16,2.26-2.26,5.92-2.25,8.17.01l.57.57h.03-.03.03c1.21-.66,2.51-1.18,3.84-1.59v-.84c0-3.19,2.58-5.77,5.77-5.77h.01c3.19,0,5.77,2.58,5.77,5.77v.84c1.33.4,2.63.92,3.84,1.59h.03-.03.03l.57-.57c2.25-2.27,5.92-2.27,8.17-.01,2.25,2.25,2.25,5.91,0,8.16l-.6.6c.66,1.21,1.18,2.51,1.59,3.84h.84c3.19,0,5.77,2.58,5.77,5.77h0c0,3.2-2.58,5.78-5.77,5.78h-.84c-.4,1.33-.92,2.63-1.59,3.84v.03" />
                      </g>
                    </svg>
                    {/* <img src={Cog} alt="Cog" style={{ filter: 'unset', width: '30px', height: '30px' }} /> */}
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="headerDropdownMenu">
                    <Link
                      to={"/settings"}
                      className="headerDropdownAction"
                    >
                      {t("header.account")}
                    </Link>

                    {
                      ((user?.status === "primary" || user?.status === "coupon") && hideUrlForAge()) && (
                        <Link
                          to={"/household-member"}
                          className="headerDropdownAction"
                        >
                          {t("header.household")}
                        </Link>
                      )
                    }

                    {
                      (user?.offer_code_show && hideUrlForAge()) ? (
                        <Link to={"/share-earn"} className="headerDropdownAction">
                          {t("header.shareEarn")}
                        </Link>
                      ) : (
                        ''
                      )
                    }

                    {/* <Link
                      to={""}
                      className="headerDropdownAction"
                    >
                      Parental Controls
                    </Link> */}
                    <Link
                      to={"https://relaxscofa.com/faq/"}
                      className="headerDropdownAction"
                    >
                      {t("header.faq")}
                    </Link>
                    <Link
                      to={"http://relaxscofa.com/support"}
                      className="headerDropdownAction"
                    >
                      {t("header.support")}
                    </Link>
                    {/* <Link
                      to={""}
                      className="headerDropdownAction"
                    >
                      Feedback
                    </Link> */}
                    <button
                      type="button"
                      className="headerDropdownAction"
                      onClick={() => setLogoutModal(true)}
                    >
                      {t("header.logout")}
                    </button>
                  </Dropdown.Menu>
                </Dropdown>

                {/* <Dropdown className="headerDropdown toggleHead">
                  <Dropdown.Toggle
                    variant="success"
                    id="language-dropdown"
                    className="headerDropdownButton p-2"
                  >
                    <svg width="25" height="25" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" fill="white" />
                    </svg>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="headerDropdownMenu">
                    {supportedLanguages.map((lang) => (
                      <button
                        type="button"
                        key={lang.code}
                        onClick={() => handleLanguageSelect(lang.code)}
                        className="headerDropdownAction"
                      >
                        {t(lang.labelKey)}
                      </button>
                    ))}
                  </Dropdown.Menu>
                </Dropdown> */}

                <button className="notButton d-flex align-items-center p-2" onClick={() => { window.location.reload(false); dispatch(userLogout()) }}>
                  <img src={RefreshIcon} alt="Refresh" style={{ filter: 'unset', width: '25px', height: '25px' }} />
                </button>

              </div>
            </div>
          </div>
        </div>
      </div>

      {/* logout modal */}
      <Modal
        show={logoutModal}
        centered
        className="soundModal"
        backdrop="static"
      >
        <Modal.Body>
          <div className="text-end">
            <button
              className="closeButton notButton ms-auto"
              onClick={() => setLogoutModal(false)}
            >
              <img src={crossIcon} alt="" />
            </button>
          </div>
          <div className="customModalContent my-5">
            <h2 className="font-16 lh-16 fw-normal mb-5 text-center">{userPrompts?.logout_message}</h2>
            <div className="d-flex align-items-center justify-content-center">
              <button style={{ backgroundColor: '#ffffff1f' }} className='mx-3 px-5 py-2 fs-6 fw-light text-white text-capitalize btn rounded-pill d-flex align-items-center justify-content-center flex-shrink-0' onClick={handleLogout}>
                <span className=''>{t("header.logoutConfirmYes")}</span>
              </button>
              <button style={{ backgroundColor: '#ffffff1f' }} className='mx-3 px-5 py-2 fs-6 fw-light text-white text-capitalize btn rounded-pill d-flex align-items-center justify-content-center flex-shrink-0' onClick={() => setLogoutModal(false)}>
                <span className=''>{t("header.logoutConfirmNo")}</span>
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* success modal */}
      <Modal
        show={succesModal}
        centered
        className="success-modal"
        backdrop="static"
      >
        <Modal.Body>
          <div className="my-5">
            <h2 className="font-16 lh-16 fw-normal my-5 text-center">{userPrompts?.logout_message_notification}</h2>
          </div>
        </Modal.Body>
      </Modal>


      <AppDownloadTray openState={showAppDownloadTray} handleCallBack={hideAppDownloadTray} />
    </>
  );
};
